/**************************************************
 * Nombre:       Home_Indicadores
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {INDICADORES, NEGRITA} from "../../../Constantes";
import {theme} from "../../../Tema";
import TarjetaIndicador from "../../Tarjetas/TarjetaIndicador";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {CountUp} from "use-count-up";
import feliz from "../../../Recursos/carafeliz.svg";

const Home_Indicadores = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <Typography
                        sx={{
                            fontFamily: NEGRITA,
                            color: theme.palette.primary.main,
                            fontSize: sCell ? 32 : 38,
                            lineHeight: 1.1,
                            textAlign: 'center'

                        }}>Nuestros indicadores</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 9}} sx={{justifyContent: 'flex-start', mt: 8}}>

                    <Grid
                        container
                        justifyContent={sCell ? 'center' : 'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={sCell ? 2 : 0}
                    >

                        <Grid container size={{xs: 6, sm: 4, md: 4}}
                              sx={{justifyContent: 'flex-start', borderRight: sCell ? 0 : 1}}>
                            <TarjetaIndicador item={INDICADORES[0]}/>
                        </Grid>

                        <Grid container size={{xs: 6, sm: 4, md: 4}}
                              sx={{justifyContent: 'flex-start', borderRight: sCell ? 0 : 1}}>
                            <Grid

                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                    <img src={feliz} width={42} height={'auto'}/>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 1, px: 2}}>
                                    <Typography sx={{fontFamily: NEGRITA, fontSize: 24, textAlign: 'center'}}>
                                        Ya perdimos la cuenta
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                    <Typography sx={{fontSize: 20, fontWeight: 600, textAlign: 'center'}}>{'Muchos Clientes Felices'}</Typography>
                                </Grid>


                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 6, sm: 4, md: 4}}
                              sx={{justifyContent: 'flex-start', borderRight: 0}}>
                            <TarjetaIndicador item={INDICADORES[2]}/>
                        </Grid>


                    </Grid>

                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Indicadores
